module.exports = __webpack_public_path__ + "img/collaborate_26.ab8d4d6c.jpg";